import Vue from 'vue';
import { request } from '@/rest-client';
import { AxiosResponse } from 'axios';

export default {
  namespaced: true,
  state: {
    requests: [],
  },
  mutations: {
    set(state: any, payload: any) {
      state.requests = payload;
    },
    show(state: any, payload: boolean) {
      state.showModal = payload;
    },
  },
  actions: {
    resetRequests({ commit }: {commit: any}): void {
      commit('set', []);
    },
    updateRequests({ commit }: {commit: any}): void {
      request('get', `requests` )
      .then((response: AxiosResponse) => {
        commit('set', response.data);
      });
    },
  },
  getters: {
    list: (state: any): object[] => state.requests || [],
  },
};

